import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiHandle } from "../config/apiHandle/apiHandle";

// Get all conversation pairs for admin
export const get_all_conversations = createAsyncThunk(
  "conversations/getAllConversations",
  async () => {
    try {
      // First try the conversations endpoint
      const response = await apiHandle.get(`/admin/conversations`);
      console.log("Conversations API response:", response.data);
      return {
        conversations: response.data.conversations || response.data.data || [],
        message: "Conversations fetched successfully",
      };
    } catch (error) {
      console.log("Error from get conversations:", error);
      console.log("Error response:", error?.response?.data);
      console.log("Error status:", error?.response?.status);

      // If the endpoint doesn't exist or fails, try fetching from orders
      try {
        console.log("Trying to fetch conversations from orders...");
        const ordersResponse = await apiHandle.get(`/admin-get-orders`);
        console.log("Orders response:", ordersResponse.data);
        const orders = ordersResponse.data.orders || ordersResponse.data.data || ordersResponse.data || [];

        // Group orders by user-vendor pairs to create conversation list
        const conversationMap = new Map();
        (Array.isArray(orders) ? orders : []).forEach(order => {
          if (order.user && order.vendor) {
            const key = `${order.user.id}-${order.vendor.id}`;
            if (!conversationMap.has(key) || new Date(order.updated_at) > new Date(conversationMap.get(key).latest_order.updated_at)) {
              conversationMap.set(key, {
                id: key,
                user: order.user,
                vendor: order.vendor,
                latest_order: {
                  id: order.id,
                  status: order.status,
                  service_name: order.service?.name || order.service_name || "Service",
                  updated_at: order.updated_at,
                },
              });
            }
          }
        });

        const conversations = Array.from(conversationMap.values());
        console.log("Conversations from orders:", conversations);

        if (conversations.length > 0) {
          return {
            conversations: conversations,
            message: "Conversations fetched from orders",
          };
        }
      } catch (ordersError) {
        console.log("Error fetching from orders:", ordersError);
      }

      throw Error(error?.response?.data?.message || error.message);
    }
  }
);
